import { Map, List } from 'immutable';

export function update(state, action) {
    let items = state.get('items');

    action.items.forEach((competition) => {
        let item = items.get(+competition.id) || Map();

        items = items.set(+competition.id, item.merge(competition));
    });

    items = items.sortBy(comp => -comp.get('displayOrder'));

    state = state.set(
        'collections',
        state.get('collections').set(
            action.id,
            Map({
                state: 'FINISHED',
                items: List(action.items.map(item => +item.id))
            })
        )
    );

    return state.set('items', items);
}
